import React from 'react'
import './Navbar.css'

export default function Navbar() {
    return(
        <div className="Navbar">

        </div>
    )
}